import { Row, Col, Avatar, Divider, Modal } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useDeleteCharacterMutation, useFetchCharactersQuery } from '../../store'
import { useAuthenticator } from '@aws-amplify/ui-react'
import { ContentCard } from '../../components/ContentCard'
import { FadeIn } from '../../components/FadeIn'
import { Overlay } from '../../components/Overlay'
import { AiOutlineCloseSquare, AiOutlinePlusSquare } from 'react-icons/ai'

import * as T from '../../components/Typography'
import { getAvatar } from '../../utils/getAvatar'
import { useEffect, useState } from 'react'

export const CharactersPage = () => {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const { user } = useAuthenticator((context) => [context.user])
  const {
    data: characters,
    isLoading,
    isFetching,
    refetch,
  } = useFetchCharactersQuery(user.username || '')
  const [deleteCharacter, characterDeletion] = useDeleteCharacterMutation()

  useEffect(() => {
    if (characterDeletion.isSuccess) refetch()
  }, [characterDeletion])

  const confirmDeletion = (character_id: string) => {
    deleteCharacter(character_id)
    setOpen(false)
  }

  return (
    <>
      <Row gutter={[4, 4]}>
        <Col style={{ textAlign: 'center' }} xs={24} sm={2}>
          <h1 style={{ margin: 0 }}>Characters</h1>
        </Col>
      </Row>
      <Divider style={{ marginTop: 12 }} />
      <Overlay isLoading={isLoading || isFetching}>
        <>
          {!isLoading && (
            <FadeIn>
              <Row gutter={[24, 24]} style={{ padding: 8 }}>
                {characters?.map((character: any) => (
                  <Col xs={24} sm={12} xl={8} key={character.id}>
                    <ContentCard>
                      <Row justify={'start'} align={'middle'}>
                        <Row
                          justify={'start'}
                          align={'middle'}
                          onClick={() => navigate(`/character/${character.id}`)}
                        >
                          <Col style={{ marginRight: 16, paddingBottom: 8 }}>
                            <Avatar size={128} src={<img src={getAvatar(character.avatar)} />} />
                          </Col>
                          <Col>
                            <T.CardTitle>{character.name}</T.CardTitle>
                            <T.CardSubheader style={{ color: '#999999' }}>
                              {character.concept}
                            </T.CardSubheader>
                            <span>
                              <T.CardDescriptionSubheader
                                style={{ marginRight: 16, paddingBottom: 8 }}
                              >
                                Adventure:{' '}
                                <span style={{ color: '#A20000' }}>
                                  {character.chronicle?.name || 'N/A'}
                                </span>
                              </T.CardDescriptionSubheader>
                            </span>
                          </Col>
                        </Row>
                        <Row
                          justify={'end'}
                          style={{ width: '100%' }}
                          align={'middle'}
                          onClick={() => setOpen(true)}
                        >
                          <AiOutlineCloseSquare color={'darkred'} size={24} />
                          <T.CardDescriptionSubheader
                            style={{ color: 'darkred', marginTop: 2, marginLeft: 4 }}
                          >
                            Delete Character
                          </T.CardDescriptionSubheader>
                        </Row>
                      </Row>
                    </ContentCard>
                    <Modal
                      title="Delete Character"
                      open={open}
                      okText={'Delete Character'}
                      okButtonProps={{ danger: true }}
                      onOk={() => confirmDeletion(character.id)}
                      onCancel={() => {
                        setOpen(false)
                      }}
                    >
                      <p>
                        Are you sure you want to delete:{' '}
                        <span style={{ fontWeight: 'bold', color: 'darkred' }}>
                          {character.name}
                        </span>
                      </p>
                    </Modal>
                  </Col>
                ))}
                <Col xs={24} sm={12} xl={8}>
                  <ContentCard
                    style={{ height: '100%' }}
                    onClick={() => navigate(`/character/create`)}
                  >
                    <Row justify={'start'} align={'middle'}>
                      <Row justify={'center'} align={'middle'}>
                        <Col style={{ marginRight: 16, paddingBottom: 8 }}>
                          <AiOutlinePlusSquare size={122} />
                        </Col>
                        <Col>
                          <T.CardTitle>New Character</T.CardTitle>
                          <T.CardSubheader style={{ color: '#999999' }}>
                            Create a new character from scratch
                          </T.CardSubheader>
                        </Col>
                      </Row>
                    </Row>
                  </ContentCard>
                </Col>
              </Row>
            </FadeIn>
          )}
        </>
      </Overlay>
    </>
  )
}
